import { useCurrentUser } from "@/lib/auth";

/**
 * Dauerhaft sichtbarer Hinweis, wenn der serverseitige Sicherheitsmodus
 * (APP_SAFETY_MODE=true) aktiv ist. Reine Anzeige – die Durchsetzung erfolgt
 * immer im Backend (blockierte Aktionen liefern HTTP 403 mit
 * error="safety_mode_blocked").
 */
export function SafetyModeBanner() {
  const { user } = useCurrentUser();
  if (!user || user.safety_mode !== true) return null;

  return (
    <div
      role="status"
      className="border-b border-red-800 bg-red-700 px-4 py-1.5 text-center text-xs font-semibold tracking-wide text-white"
    >
      SICHERHEITSMODUS AKTIV – externe Schreibzugriffe und produktive
      Benachrichtigungen sind blockiert.
    </div>
  );
}
